import React, { useState } from 'react';
import { AgendaSlotList } from './AgendaSlotList';
import { AgendaTabs } from './AgendaTabs';
import { Slot, Tab } from './types';

import { DEFAULT_MAX_SLOTS } from '../../../Agenda/constants';
import styles from './AgendaView.module.scss';

interface AgendaViewProps {
    tabs: Tab[];
    maxSlots?: number;
    onActiveTabChange?: (tab: Tab) => void;
    agendaTabsRef: React.RefObject<HTMLDivElement>;
}

export const AgendaView = ({
    tabs,
    agendaTabsRef,
    maxSlots = DEFAULT_MAX_SLOTS,
    onActiveTabChange,
}: AgendaViewProps) => {
    const [activeTab, setActiveTab] = useState<Tab>(tabs[0]);

    const activeTabIndex = tabs.findIndex((tab) => tab.name === activeTab.name);

    const keyFactory = (slot: Slot, index: number) => {
        return `${activeTab.name}-${slot.title}-${slot.startTime}-${slot.endTime}-${activeTabIndex}-${index}`;
    };

    const handleTabClick = (tab: Tab) => {
        setActiveTab(tab);
        onActiveTabChange && onActiveTabChange(tab);
    };

    return (
        <div className={styles.agendaView}>
            <AgendaTabs
                tabs={tabs}
                onTabClick={handleTabClick}
                ref={agendaTabsRef}
            />
            <AgendaSlotList
                slots={activeTab.slots}
                maxSlots={maxSlots}
                keyFactory={keyFactory}
            />
        </div>
    );
};
